export default __webpack_public_path__ + "static/media/May_08.d18b45ac.png";